/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTournamentWinnerPlayerDtoSchema = z.object({
  name: z.string().nullish(),
  avatar: z.string().nullish(),
  userId: z.string().nullish(),
  username: z.string().nullish(),
});
